<script setup lang="ts">
const { t } = useI18n()
</script>

<template>
  <footer class="layout-footer mt-4 pt-4 flex flex flex-col items-center justify-center">
    <small class="text-center space-x-2">
      <span>{{ t('footer.copyright', { year: new Date().getFullYear() }) }}</span>
      <a href="https://swipe4work.com/werkgevers/" target="_blank">{{ 'Swipe4Work' }}</a>
      <span>|</span>
      <span>{{ '3.0.0' }}</span>
      <br>
    </small>
  </footer>
</template>

<style scoped lang="scss">
@use '@/sass/_variables' as contants;

.layout-footer {
  transition: margin-left contants.$transitionDuration;
  border-top: 1px solid var(--surface-border);
}
</style>
